import React from 'react';
import { c as classNames } from '../../../../index-e609ebf3.js';
import '../../../../_commonjsHelpers-17aad09c.js';

var ListFilterHeaderItem = function (_a) {
    var children = _a.children, _b = _a.title, title = _b === void 0 ? '' : _b, isActive = _a.isActive, onClick = _a.onClick;
    var listFilterHeaderItemClassNames = classNames('lists-title-row-filter-item', {
        active: isActive,
    });
    return (React.createElement("div", { className: listFilterHeaderItemClassNames, onClick: onClick },
        React.createElement("p", { className: 'lists-title-row-filter-item-txt', title: title }, children)));
};

export { ListFilterHeaderItem };
